import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-documents-icon',
  templateUrl: './documents-icon.component.html',
  styleUrls: ['./documents-icon.component.scss'],
})
export class DocumentsIconComponent {
  @Input() type: 'full-tray' | 'empty-tray' | 'floppy-disk';
}
